<template>
  <section id="balao-pergunta" class="d-flex align-items-stretch flex-column">
    <div class="speech-bubble w-100">
      <h6 class="font-weight-bold md-title mt-0 mb-1">Pergunta</h6>
      <p class="m-0 md-body-2">
        {{ texto }}
      </p>
    </div>
    <h6 class="mt-3 md-body-2 mb-2 align-self-center">Compartilhar</h6>
    <div class="d-flex  align-self-center">
      <social-sharing url="http://virtex.com.br/" :title="descricao"
                      :description="descricao" :quote="descricao" inline-template>
        <div>
          <network network="facebook">
            <md-button class="md-icon-button md-primary">
              <md-icon class="socicon-facebook"></md-icon>
            </md-button>
          </network>
          <network network="whatsapp">
            <md-button class="md-icon-button md-primary">
              <md-icon class="socicon-whatsapp"></md-icon>
            </md-button>
          </network>
          <network network="linkedin">
            <md-button class="md-icon-button md-primary">
              <md-icon class="socicon-linkedin"></md-icon>
            </md-button>
          </network>
          <network network="twitter">
            <md-button class="md-icon-button md-primary">
              <md-icon class="socicon-twitter"></md-icon>
            </md-button>
          </network>
        </div>
      </social-sharing>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'BalaoPergunta',
    data() {
      return {
        descricao: ""
      }
    },
    props: {
      texto: { default: "Texto" },
      textoResposta: { default: "Outro Texto" }
    },
    created() {
        this.descricao = `VirteX Telecom\nPergunta:\n${this.texto}\nResposta:\n${this.textoResposta}\n`
    }
  }
</script>

<style lang="scss" scoped>

  $branco-gelo: #f3f3f3;

  .speech-bubble {
    position: relative;
    background: $branco-gelo;
    border-radius: .4em;
    margin-left: 20px;
    padding: 15px;
    color: #cc0000;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.27));
  }

  .speech-bubble:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 22px solid transparent;
    border-right-color: $branco-gelo;
    border-left: 0;
    border-top: 0;
    margin-top: -11px;
    margin-left: -22px;
  }

</style>
